module.exports = __webpack_public_path__ + "img/archive-fill.256115d4.svg";